<template>
  <v-row justify="end">
    <SnackBar ref="snackbar" />
    <v-dialog v-model="dialog" width="680">
      <template #activator="{ props }">
        <v-btn
          color="#004984"
          v-bind="props"
          class="button-config"
          style="color: white"
        >
          Cadastrar Tarefa
          <v-icon right style="margin-left: 5px"
            >mdi-checkbox-marked-circle-plus-outline</v-icon
          >
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="text-h5"
            >[{{ this.siglaDoProjeto }}] - Cadastrar Tarefa</span
          >
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="8">
                <v-text-field
                  v-model="nome"
                  variant="underlined"
                  label="Nome da tarefa*"
                  required
                  hint="Utilize uma descrição de no máximo 68 caracteres"
                  counter
                  :rules="[validateNome]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="8" md="4">
                <v-select
                  v-model="this.pontoSelecionado"
                  variant="underlined"
                  label="Story Points*"
                  :items="pontos"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="8" md="6">
                <v-select
                  v-model="this.repositorioSelecionado"
                  variant="underlined"
                  label="Repositório"
                  :items="repositorios"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="8" md="6">
                <v-select
                  v-model="this.prioridade"
                  variant="underlined"
                  label="Prioridade*"
                  :items="prioridades"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="8" md="12">
                <v-select
                  v-model="this.tipo"
                  variant="underlined"
                  label="Tipo de Tarefa*"
                  :items="tipos"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="descricao"
                  variant="underlined"
                  counter
                  no-resize
                  rows="4"
                  label="Descrição*"
                  hint="Utilize uma descrição de no máximo 255 caracteres"
                ></v-textarea>
              </v-col>
              <v-col
                v-if="this.tipo == 'IMPLEMENTACAO'"
                cols="12"
                sm="8"
                md="9"
              >
                <v-select
                  v-model="this.tipoImplementacao"
                  variant="underlined"
                  label="Tipo de Implementação*"
                  :items="tiposImplementacao"
                ></v-select>
              </v-col>
              <v-col
                v-if="this.tipo == 'IMPLEMENTACAO'"
                cols="12"
                sm="8"
                md="9"
              >
                <v-select
                  v-model="csuSelecionados"
                  variant="underlined"
                  :items="casosDeUsos"
                  label="Casos de uso*"
                  multiple
                >
                </v-select>
              </v-col>
            </v-row>
          </v-container>
          <small>*Campos Obrigatórios</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue-darken-1" variant="text" @click="close">
            Cancelar
          </v-btn>
          <v-btn color="blue-darken-1" variant="text" @click="registerTask">
            Cadastrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import axios from 'axios';

import SnackBar from '@/components/SnackBar.vue';
import store from '@/store/store';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000';

export default {
  /* eslint-disable*/
  /**
   * Objeto de dados para componente.
   * @typedef {Object} ComponentData
   * @property {boolean} dialog - Determina se a caixa de diálogo está aberta ou não.
   * @property {string} nome - O nome da tarefa.
   * @property {string} pontos - O número de pontos para a tarefa.
   * @property {string} prioridade - A prioridade da tarefa.
   * @property {string} tipo - O tipo da tarefa.
   * @property {string} tipoImplementacao - O tipo de implementação da tarefa.
   * @property {string} descricao - A descrição da tarefa.
   * @property {string} tarefaId - O ID da tarefa.
   * @property {Array} casosDeUsos - Uma matriz de casos de uso.
   * @property {Array} csuSelecionados - Uma matriz de casos de uso selecionados.
   * @property {Array} csuIds - Uma matriz de IDs de caso de uso.
   * @property {Array} items - Uma matriz de itens.
   * @property {Array} - Uma matriz de tipos de tarefas.
   * @property {Array} tiposImplementacao - Uma matriz de tipos de implementação.
   */

  /**
   * Dados do componente.
   * @type {ComponentData}
   */
  props: {
    idProjeto: {
      type: Number,
      default: null,
    },
  },
  components: {
    SnackBar,
  },
  data: () => ({
    id_repo: null,
    dialog: false,
    nome: null,
    siglaDoProjeto: null,
    pontos: ['0', '1/2', '1', '2', '3', '5', '8', '13', '20', '40', '?'],
    pontoSelecionado: null,
    prioridade: null,
    repositorioSelecionado: null,
    prioridades: ['URGENTE', 'ALTA', 'MEDIA', 'BAIXA'],
    tipo: null,
    tipoImplementacao: null,
    descricao: null,
    tarefaId: null,
    casosDeUsos: [],
    csuSelecionados: [],
    csuIds: [],
    items: [],
    repositorios: [],
    tipos: [
      'TECNICA',
      'DOCUMENTACAO',
      'IMPLEMENTACAO',
      'TESTE_INDEPENDENTE',
      'TESTE_EQUIPE',
    ],
    tiposImplementacao: ['FUNCIONALIDADE', 'TESTE_AUTOMATIZADO'],
    dadosRepositorios: null,
  }),
  created() {
    this.getCsu();
    axios
      .get(API_URL + `/projetos/${this.idProjeto}/repositorios`, {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        },
      })
      .then((response) => {
        this.dadosRepositorios = response.data;
        response.data.forEach((element) => {
          this.repositorios.push(element.tb_repositorio.nome);
        });
        console.log(this.repositorios);
      })
      .catch((error) => {
        console.error(error);
      });

    axios
      .get(API_URL + `/projetos/listaprojeto/${this.idProjeto}`, {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        },
      })
      .then((response) => {
        this.siglaDoProjeto = response.data.sigla;
      })
      .catch((error) => {
        console.error(error);
      });
  },
  methods: {
    close() {
      this.dialog = false;
      this.nome = null;
      this.descricao = null;
      this.pontos = null;
      this.prioridade = null;
      this.tipo = null;
      this.id_repo = null;
    },
    getCsu() {
      axios
        .get(API_URL + '/api/v1/productBacklog/projeto/' + this.idProjeto, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((response) => {
          this.items = response.data.useCases;
          console.log(this.items);
          this.listaCsu();
        })
        .catch((error) => {
          console.error(error);
        });
    },
    listaCsu() {
      for (var i = 0; i < this.items.length; i++) {
        this.casosDeUsos.push(this.items[i].nome);
      }
    },
    pegaIdCsu() {
      for (var i = 0; i < this.csuSelecionados.length; i++) {
        for (var j = 0; j < this.items.length; j++) {
          if (this.csuSelecionados[i] == this.items[j].nome) {
            this.csuIds.push(this.items[j].id_caso_de_uso);
          }
        }
      }
    },
    registerTask() {
      this.dadosRepositorios.forEach((element) => {
        if (element.tb_repositorio.nome == this.repositorioSelecionado) {
          this.id_repo = element.tb_repositorio.id_repositorio;
        }
      });

      const data = {
        titulo: this.nome,
        descricao: this.descricao,
        storypoint: this.pontoSelecionado,
        prioridade: this.prioridade,
        id_repo: this.id_repo,
        tipo_tarefa: this.tipo, // eslint-disable-line
        id_projeto: parseInt(this.idProjeto), // eslint-disable-line
      };

      console.log(data);

      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${store.state.token}`,
        },
      };
      /* TODO: Olhar direitinho essa pois possui chamadas encadeadas */
      axios
        .post(API_URL + '/tarefas/criar', data, config)
        .then((response) => {
          this.dialog = false;
          this.tarefaId = parseInt(response.data.resposta.id_tarefa);
          if (this.tipo == 'IMPLEMENTACAO') {
            this.pegaIdCsu();
            const data = {
              tipo_implementacao: this.tipoImplementacao, // eslint-disable-line
              id_tarefa: this.tarefaId, // eslint-disable-line
              casosDeUsos: this.csuIds,
            };
            axios
              .post(API_URL + '/api/v1/implementacao/varios', data, config)
              .then((response) => {
                console.log(response.data);
                this.$refs.snackbar.showSuccessSnackbar(
                  'Concluído!',
                  'Implementacao ' + this.nome + ' cadastrada com sucesso!'
                );
              })
              .catch((error) => {
                console.error(error);
                this.$refs.snackbar.showErrorSnackbar(
                  'Hm... Algo deu errado',
                  'Por algum motivo, não conseguimos registrar sua tarefa. Verifique os dados e tente novamente.'
                );
              });
          }
          this.$refs.snackbar.showSuccessSnackbar(
            'Concluído!',
            'Tarefa ' + this.nome + ' cadastrada com sucesso!'
          );
          /*TODO: Maneira rápida. Ajeitar reloads... */
          setTimeout(() => {
            location.reload();
          }, 2000);
        })
        .catch((error) => {
          console.log(error.response.data.error);
          this.$refs.snackbar.showErrorSnackbar(
            'Hm... Algo deu errado',
            'Por algum motivo, não conseguimos registrar sua tarefa. Verifique os dados e tente novamente.'
          );
        });
    },
    validateNome(value) {
      // Use uma expressão regular para permitir letras, espaços em branco e caracteres especiais, mas não apenas números
      const regex =
        /^(?=.*[A-Za-z\s])[\w\s!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~çÇáéíóúÁÉÍÓÚâêîôÂÊÎÔãõÃÕ]+$/u;
      if (!regex.test(value)) {
        return 'O texto inserido contém caracteres inválidos.';
      }
      return true;
    },
  },
};
</script>
